export default __webpack_public_path__ + "static/quentin-webfont-58ca535aa88d47ef2145a5b57e429d24.woff2";